import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import EntityForm from "@/admin/components/EntityForm";
import Container from "@/components/containers/Container";
import { type ChildRouteContext } from "@/root";

export const Route = createFileRoute(
  "/admin/_panel/_settings/settings/entity/create",
)({
  component: Component,
  beforeLoad: ({ context }) =>
    ({
      title: () => context.t("Entities", { ns: "core.shared" }),
      crumb: [
        {
          label: context.t("Create Base Entity", { ns: "core.shared" }),
        },
      ],
    }) satisfies ChildRouteContext,
});

function Component() {
  const { t } = useTranslation("core.shared");

  return (
    <Container
      title={t("Create Base Entity")}
      description={t("Manage, create and edit base entities")}
      className="flex h-full flex-col"
    >
      <EntityForm />
    </Container>
  );
}
